import React from 'react'

export const NAVY = '#303743'
export const OLIVE = '#486039'
/** Fine line weight for 80×80 icon viewBox */
export const MODALITY_STROKE = 1.35

/** Slightly heavier stroke for small line-variant icons in the nav mega menu */
const MENU_LINE_STROKE = 1.65

/** Default size on modalities-rates column layout */
export const MODALITY_ICON_COLUMN_CLASS =
  'w-[5.25rem] h-[5.25rem] sm:w-28 sm:h-28 lg:w-[8.75rem] lg:h-[8.75rem] max-w-full shrink-0'

/** Compact size for mega menu / mobile services list */
export const MODALITY_ICON_MENU_CLASS = 'h-9 w-9 shrink-0 max-w-full'

export function IconSlidingScale({ className = MODALITY_ICON_COLUMN_CLASS, variant = 'filled' }) {
  if (variant === 'line') {
    return (
      <svg viewBox="0 0 80 80" className={className} aria-hidden>
        <text
          x="40"
          y="52"
          textAnchor="middle"
          fill="currentColor"
          fontSize="34"
          fontWeight="500"
          fontFamily="system-ui, sans-serif"
        >
          $
        </text>
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden>
      <circle cx="40" cy="40" r="36" fill={NAVY} />
      <circle cx="40" cy="40" r="28" fill="none" stroke="#fff" strokeWidth={MODALITY_STROKE} />
      <text
        x="40"
        y="50"
        textAnchor="middle"
        fill="#fff"
        fontSize="32"
        fontWeight="400"
        fontFamily="system-ui, sans-serif"
      >
        $
      </text>
    </svg>
  )
}

export function IconEmdr({ className = MODALITY_ICON_COLUMN_CLASS, variant = 'filled' }) {
  if (variant === 'line') {
    return (
      <svg viewBox="0 0 80 80" className={className} aria-hidden>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={MENU_LINE_STROKE}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 41c5.5-8 13.5-12 19-12s13.5 4 19 12c-5.5 8-13.5 12-19 12s-13.5-4-19-12z"
        />
        <circle cx="40" cy="41" r="8.5" fill="none" stroke="currentColor" strokeWidth={MENU_LINE_STROKE} />
        <circle cx="40" cy="41" r="3.75" fill="currentColor" />
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden>
      <circle cx="40" cy="40" r="36" fill={OLIVE} />
      <path
        fill="none"
        stroke="#fff"
        strokeWidth={MODALITY_STROKE}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 41c5.5-8 13.5-12 19-12s13.5 4 19 12c-5.5 8-13.5 12-19 12s-13.5-4-19-12z"
      />
      <circle cx="40" cy="41" r="8.5" fill="#fff" />
      <circle cx="40" cy="41" r="3.75" fill={OLIVE} />
    </svg>
  )
}

export function IconChildBlocks({ className = MODALITY_ICON_COLUMN_CLASS, variant = 'filled' }) {
  if (variant === 'line') {
    return (
      <svg viewBox="0 0 80 80" className={className} aria-hidden>
        <g fill="none" stroke="currentColor" strokeWidth={MENU_LINE_STROKE} strokeLinejoin="round">
          <rect x="24" y="44" width="14" height="14" rx="1" />
          <rect x="42" y="44" width="14" height="14" rx="1" />
          <rect x="33" y="28" width="14" height="14" rx="1" />
        </g>
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden>
      <circle cx="40" cy="40" r="36" fill={NAVY} />
      <g fill="none" stroke="#fff" strokeWidth={MODALITY_STROKE} strokeLinejoin="round">
        <rect x="24" y="44" width="14" height="14" rx="1" />
        <rect x="42" y="44" width="14" height="14" rx="1" />
        <rect x="33" y="28" width="14" height="14" rx="1" />
      </g>
    </svg>
  )
}

export function IconFamily({ className = MODALITY_ICON_COLUMN_CLASS, variant = 'filled' }) {
  if (variant === 'line') {
    return (
      <svg viewBox="0 0 80 80" className={className} aria-hidden>
        <g fill="none" stroke="currentColor" strokeWidth={MENU_LINE_STROKE} strokeLinecap="round" strokeLinejoin="round">
          <circle cx="26" cy="30" r="6" />
          <path d="M16 56V48c0-4.5 4.5-9 10-9s10 4.5 10 9v8" />
          <circle cx="54" cy="30" r="6" />
          <path d="M64 56V48c0-4.5-4.5-9-10-9s-10 4.5-10 9v8" />
          <circle cx="40" cy="35" r="5.25" />
          <path d="M32 58V49c0-3.5 3.2-6.5 8-6.5s8 3 8 6.5v9" />
        </g>
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden>
      <circle cx="40" cy="40" r="36" fill={OLIVE} />
      <g fill="none" stroke="#fff" strokeWidth={MODALITY_STROKE} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="26" cy="30" r="6" />
        <path d="M16 56V48c0-4.5 4.5-9 10-9s10 4.5 10 9v8" />
        <circle cx="54" cy="30" r="6" />
        <path d="M64 56V48c0-4.5-4.5-9-10-9s-10 4.5-10 9v8" />
        <circle cx="40" cy="35" r="5.25" />
        <path d="M32 58V49c0-3.5 3.2-6.5 8-6.5s8 3 8 6.5v9" />
      </g>
    </svg>
  )
}

export function IconIndividual({ className = MODALITY_ICON_COLUMN_CLASS, variant = 'filled' }) {
  if (variant === 'line') {
    return (
      <svg viewBox="0 0 80 80" className={className} aria-hidden>
        <g fill="none" stroke="currentColor" strokeWidth={MENU_LINE_STROKE} strokeLinecap="round" strokeLinejoin="round">
          <circle cx="40" cy="29" r="9.5" />
          <path d="M22 58v-3c0-7.5 6-13.5 18-13.5s18 6 18 13.5v3" />
        </g>
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden>
      <circle cx="40" cy="40" r="36" fill={NAVY} />
      <g fill="none" stroke="#fff" strokeWidth={MODALITY_STROKE} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="40" cy="29" r="9.5" />
        <path d="M22 58v-3c0-7.5 6-13.5 18-13.5s18 6 18 13.5v3" />
      </g>
    </svg>
  )
}

/** Services / modalities catalog — navy circle, list motif (mega menu + optional reuse). */
export function IconServicesModalities({ className = MODALITY_ICON_COLUMN_CLASS, variant = 'filled' }) {
  if (variant === 'line') {
    return (
      <svg viewBox="0 0 80 80" className={className} aria-hidden>
        <g stroke="currentColor" strokeWidth={MENU_LINE_STROKE} strokeLinecap="round" strokeLinejoin="round">
          <line x1="30" y1="26" x2="54" y2="26" fill="none" />
          <line x1="30" y1="40" x2="54" y2="40" fill="none" />
          <line x1="30" y1="54" x2="48" y2="54" fill="none" />
          <circle cx="24" cy="26" r="2.75" fill="currentColor" stroke="none" />
          <circle cx="24" cy="40" r="2.75" fill="currentColor" stroke="none" />
          <circle cx="24" cy="54" r="2.75" fill="currentColor" stroke="none" />
        </g>
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 80 80" className={className} aria-hidden>
      <circle cx="40" cy="40" r="36" fill={OLIVE} />
      <g fill="none" stroke="#fff" strokeWidth={MODALITY_STROKE} strokeLinecap="round" strokeLinejoin="round">
        <line x1="30" y1="26" x2="54" y2="26" />
        <line x1="30" y1="40" x2="54" y2="40" />
        <line x1="30" y1="54" x2="48" y2="54" />
        <circle cx="24" cy="26" r="2.75" fill="#fff" stroke="none" />
        <circle cx="24" cy="40" r="2.75" fill="#fff" stroke="none" />
        <circle cx="24" cy="54" r="2.75" fill="#fff" stroke="none" />
      </g>
    </svg>
  )
}

export const MODALITY_ICONS_BY_COLUMN_ORDER = [
  IconSlidingScale,
  IconEmdr,
  IconChildBlocks,
  IconFamily,
  IconIndividual
]
